var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Picture Upload")]),(_vm.screen)?_c('div',{staticClass:"flex flex-col gap-4"},[_c('img',{staticClass:"object-scale-down",staticStyle:{"max-height":"80vh"},attrs:{"src":_vm.screen.file.link}}),_c('div',{staticClass:"flex justify-end w-100"},[_vm._v(" "+_vm._s(_vm.screen.file_date)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }